<div
  class="file-dropzone"
  [class.drag-over]="isDragOver"
  [class.disabled]="isDisabled"
  [class.has-files]="hasFiles"
  [class.uploading]="isUploading()"
  [class.has-error]="!!errorMessage()"
  (dragover)="onDragOver($event)"
  (dragleave)="onDragLeave($event)"
  (drop)="onDrop($event)"
  (click)="onDropzoneClick()">

  <!-- Uploading State -->
  @if (isUploading()) {
    <div class="uploading-content">
      <div class="upload-spinner">
        <app-spinner type="simple"></app-spinner>
      </div>

      <div class="upload-title">Uploading...</div>
      <div class="upload-description">Please wait while we process your files</div>

      @if (uploadProgress()) {
        <div class="progress-container">
          <div class="progress-bar">
            <div
              class="progress-fill"
              [style.width.%]="progressPercentage">
            </div>
          </div>
          <div class="progress-text">
            {{ uploadProgress()!.loaded | number:'1.0-0' }} / {{ uploadProgress()!.total | number:'1.0-0' }} bytes
            ({{ progressPercentage | number:'1.0-1' }}%)
          </div>
        </div>
      }

      <button
        type="button"
        class="cancel-button"
        (click)="cancelUpload(); $event.stopPropagation()">
        Cancel Upload
      </button>
    </div>
  }

  <!-- Error State -->
  @else if (errorMessage()) {
    <div class="error-content">
      <div class="error-icon">
        <svg width="48" height="48" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <circle cx="12" cy="12" r="10" stroke="currentColor" stroke-width="2"/>
          <line x1="15" y1="9" x2="9" y2="15" stroke="currentColor" stroke-width="2"/>
          <line x1="9" y1="9" x2="15" y2="15" stroke="currentColor" stroke-width="2"/>
        </svg>
      </div>
      <div class="error-title">Upload Failed</div>
      <div class="error-message">{{ errorMessage() }}</div>
      <button
        type="button"
        class="retry-button"
        (click)="clearFiles(); $event.stopPropagation()">
        Try Again
      </button>
    </div>
  }

  <!-- Files Selected State -->
  @else if (hasFiles) {
    <div class="files-content">
      <div class="files-header">
        <div class="files-title">{{ currentFiles.length }} file(s) selected</div>
        <button
          type="button"
          class="clear-button"
          (click)="clearFiles(); $event.stopPropagation()">
          Clear All
        </button>
      </div>

      <div class="files-list">
        @for (file of currentFiles; track file.name; let i = $index) {
          <div class="file-item">
            <div class="file-icon">
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                <polyline points="14,2 14,8 20,8" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
            </div>
            <div class="file-info">
              <div class="file-name">{{ file.name }}</div>
              <div class="file-size">{{ formatFileSize(file.size) }}</div>
            </div>
            <button
              type="button"
              class="remove-file-button"
              (click)="removeFile(i); $event.stopPropagation()">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <line x1="18" y1="6" x2="6" y2="18" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                <line x1="6" y1="6" x2="18" y2="18" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
            </button>
          </div>
        }
      </div>

      <div class="files-footer">
        <button
          type="button"
          class="change-files-button"
          (click)="onDropzoneClick(); $event.stopPropagation()">
          {{ changeLabel() }}
        </button>
      </div>
    </div>
  }

  <!-- Default State -->
  @else {
    <div class="default-content">
      <div class="upload-icon">
        <svg width="64" height="64" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          <polyline points="7,10 12,15 17,10" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          <line x1="12" y1="15" x2="12" y2="3" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      </div>

      <div class="dropzone-title">{{ title() }}</div>
      @if (subtitle()) {
        <div class="dropzone-subtitle">{{ subtitle() }}: {{ acceptedTypesString }}</div>
      }
      <div class="dropzone-description">{{ description() }}</div>

      @if (config().maxFileSize) {
        <div class="file-size-limit">
          Maximum file size: {{ formatFileSize(config().maxFileSize!) }}
        </div>
      }
    </div>
  }
</div>
